import { render, staticRenderFns } from "./RichtextField.vue?vue&type=template&id=776f23bb&lang=pug&"
import script from "./RichtextField.vue?vue&type=script&lang=ts&"
export * from "./RichtextField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports